import { render, staticRenderFns } from "./LmListV2.vue?vue&type=template&id=118af0db&scoped=true&"
import script from "./LmListV2.vue?vue&type=script&lang=js&"
export * from "./LmListV2.vue?vue&type=script&lang=js&"
import style0 from "./LmListV2.vue?vue&type=style&index=0&id=118af0db&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118af0db",
  null
  
)

export default component.exports